import { module } from 'angular';
import { AppComponent } from './app.component';
import { appRoutesConfig } from './app-routing';
import { animateConfig, compileConfig, locationConfig } from './config';
import { StatesModule } from './states/states.module';
import { StatesMobileModule } from './states_mobile/states.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { checkAuthOnRun, locationChangeConfigRun, uiRouterErrorHandlerRunConfig } from './run';
import { AppService } from './app.service';
import { TransitionBarModule } from './ui/transition-bar/transition-bar.module';
import { GmcTooltipModule } from './ui/gmc-tooltip/gmc-tooltip.module';
import { GmcModalModule } from './components/modals/gmc-modal/gmc-modal.module';

const isMobile = window.innerWidth < 800;
const currentState = isMobile ? StatesMobileModule : StatesModule;

export let AppModule = module('app', [
  'ngMessages',
  'ngSanitize',
  'ui.router',
  'oc.lazyLoad',
  'ngAnimate',
  'angular-jwt',
  'toastr',
  'ngFileUpload',
  'ngCookies',
  CoreModule,
  SharedModule,
  currentState,
  TransitionBarModule,
  GmcTooltipModule,
  GmcModalModule
])
  .component('app', AppComponent)
  .service(AppService.name, AppService)
  .config(locationConfig)
  .config(animateConfig)
  .config(compileConfig)
  .config(appRoutesConfig)
  .run(uiRouterErrorHandlerRunConfig)
  .run(checkAuthOnRun)
  .run(locationChangeConfigRun);



// WEBPACK FOOTER //
// ./app/app.module.ts